import { useLingui } from '@lingui/react/macro'
import Image from 'next/image'

export const ErrorMsg = ({
	message,
	children,
}: {
	message?: string
	children?: React.ReactNode
}) => {
	const { t } = useLingui()

	return (
		<div className='flex flex-col items-center gap-6'>
			<Image
				src='/images/error.png'
				alt='Scheduler'
				width={400}
				height={400}
			/>

			<div className='flex flex-col items-center gap-2 text-center leading-none'>
				<div className='font-bold text-2xl text-foreground/80'>OUPS...</div>
				<div className='text-center text-muted-foreground'>
					{message ?? t`Une erreur est survenue`}
				</div>
			</div>

			{children}
		</div>
	)
}
